import * as React from 'react';
import { FunctionComponent, useState, useEffect } from 'react';
import {
  Button,
  Checkbox,
  Modal,
  notification,
  NotificationType,
  Spinner
} from '@iba-team/portal-react-components/dist';
import { ReactComponent as WhatsNewIcon } from '../../assets/whatnew.svg';
import { observer } from 'mobx-react';
import './NewsModalStyles.scss';
import { useTranslation } from 'react-i18next';
import { UserStore } from '../../store/User';
import { SystemStore } from '../../store/System';

export interface Props{
  onClose: () => void
}

export const NewsModal:FunctionComponent<Props> = observer((props) => {
  const [checked,setChecked] = useState(false);
  const {t} = useTranslation();
  const [isFetchedContent, setIsFetchedContent] = useState(false);
  const [content, setContent] = useState<JSX.Element | undefined>(undefined);
  const {profile} = UserStore;
  const {setShowNewsModalRequest} = SystemStore;
  const handleClick = () => {
    props.onClose();
    try {
      setShowNewsModalRequest();
    }
    catch {
      notification.open({
        type: NotificationType.ERROR,
        title:  t('error'),
        description: 'Something went wrong...'
      });
    }
  };

  const getTemplateNews = async (title:string,content:string,img:string) => {
    return (
      <div>
        <div className={'news_modal__title'} dangerouslySetInnerHTML={{ __html: title }}></div>
        <div className={'news_modal__location'}>
          {t(profile.countryCode)}
        </div>
        <div className={'news_modal__content'} dangerouslySetInnerHTML={{ __html: content }}>
        </div>
        <img alt={''} src={img} />
      </div>
    );
  };


  const fn = async() => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const currentIcon = require(`../../assets/balance_${profile.countryCode.replace(/_|\s+/g, '-')}.png`).default;
    return getTemplateNews(t(`newsModal.${profile.countryCode}.whatsNewTitle`),t(`newsModal.${profile.countryCode}.whatsNewContent`), currentIcon);
  };

  const chooseNewsContent =  async () => {
    setIsFetchedContent(false);
    const res = await fn();
    setContent(res);
    setIsFetchedContent(true);
  };

  useEffect(()=> {
    chooseNewsContent();
  }, [profile]);

  return(
    <Modal className={`news_modal ${!isFetchedContent && 'news_modal_loading'}`} titleText={<WhatsNewIcon/>} visible footer={[
      <>
        {isFetchedContent &&
          <>
            <Checkbox checked={checked} setChecked={setChecked} label={t('readNewRules')} />
            <Button theme={{ variant: 'primary', color: 'green' }} onClick={handleClick} disabled={!checked}>
              {t('continue')}
            </Button>
          </>
        }
      </>
    ]}
    onClose={props.onClose}>
      <div className={'news_modal_content'}>
        {!isFetchedContent ? <Spinner/> :  <div>{content}</div>}
      </div>
    </Modal>
  );
});
